export const grid = {
  maxWidth: 1280,
  columnCount: 12,
  columnGap: 20
};
